export default __webpack_public_path__ + "static/media/meta-mask-big.63a68cb8.svg";